import React, { useEffect, useState } from "react";
import DataTable from "../../../Common/Components/DataTable";
import Loading from "../../../Common/Components/Loading";
import { getUserList } from "./Components/Services";
import { Fragment } from "react";
import TopBoxDetail from "../../../../App/Panel/components/TopBoxDetail";
import ReserveItem from "../../../../App/Panel/components/reserveItem";
import { ToDateJalali, sepJustMoney } from "../../../Common/Function";
function List({ isApp }) {
  const [table, setTable] = useState({});
  const [loading, setLoading] = useState(true);
  useEffect(() => {
    HandlerRequest();
  }, []);
  const HandlerRequest = data => {
    setLoading(true);
    getUserList(data).then(data => {
      setTable(data.withdraws);
      setLoading(false);
    });
  };

  const checkStats = (data) => {
    switch (data) {
      case "waiting":
        return { text: "در حال انتظار", color: "#F5BC1A" }
      case "done":
        return { text: "پرداخت شده", color: "#1BA462" }
      case "waittoverifi":
        return { text: "در انتظار تایید", color: "#F5BC1A" }
      default:
        return { text: "---", color: "#e1e1e1" }
    }
  }
  const checkTypePay = (data) => {
    switch (data) {
      case "walletsharge":
        return "شارژ کیف پول"
      case "reserve":
        return "خرید با کیف پول"
      case "joinclass":
        return "ثبت نام در کلاس"

      default:
        return "ثبت نشده"
    }
  }

  const boxDetail = [
    { label: "آیتم", val: table?.total },
    { label: "مجموع", val: "---" }
  ]
  return (
    <div>

      {isApp &&
        <Fragment>
          <TopBoxDetail data={boxDetail} />
          {table?.data && table.data.length > 0
            ? table.data.map((item, index) => (
              <ReserveItem key={index}
                link={`#`}
                statusColor={checkStats(item.status).color}
                statusText={checkStats(item.status).text}
                r1={`مبلغ: ${sepJustMoney(item?.amount)} تومان`}
                r3={<span><span>شماره شبا :</span><br /><span>{item.bankNumber}</span></span>}
                l1={<span><span>نام بانک : </span><br /><span>{item?.moneydetails?.bank_name}</span></span>}
                l2={ToDateJalali(item.created_at)}
              />

            ))
            : <p className="text-center">موردی یافت نشد</p>
          }
        </Fragment>
      }

      {!isApp &&
        <DataTable
          loading={loading}
          heads={[
            {
              title: "مبلغ",
              key: "amount",
            },
            {
              title: "شماره شبا",
              key: "bankNumber",
            },
            {
              title: "وضعیت",
              key: "status",
              type: "enum",
              enum: {
                waiting: "در حال انتظار",
                done: "پرداخت شده",
              },
            },
            {
              title: "تاریخ ایجاد",
              key: "created_at",
              type: "date",
              timetype: "date-time",
            },
            {
              title: "اخرین بروز رسانی",
              key: "updated_at",
              type: "date",
              timetype: "date-time",
            },
          ]}
          textEmpty="تراکنشی ثبت نشده است"
          list={table && table.data}
          data={table}
          function={HandlerRequest}
          header="لیست درخواست های برداشت درآمد"
        />
      }
    </div>
  );
}

export default List;
